(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../sheets-fixed", "../transition", "../_util", "../_mixins/osProps"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../sheets-fixed"), require("../transition"), require("../_util"), require("../_mixins/osProps"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.sheetsFixed, global.transition, global._util, global.osProps);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _sheetsFixed, _transition, _util, _osProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _sheetsFixed = _interopRequireDefault(_sheetsFixed);
  _transition = _interopRequireDefault(_transition);
  _osProps = _interopRequireDefault(_osProps);

  var _components;

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-vmic-address-picker"
      }, [_c('nx-sheets-fixed', {
        attrs: {
          "sheetsTitle": _vm.sheetsTitle,
          "slideDownDisappear": _vm.slideDownDisappear,
          "backClosePopup": _vm.backClosePopup,
          "backClosePopupCustomEvent": _vm.backClosePopupCustomEvent,
          "isWebviewFull": _vm.isWebviewFull,
          "position": "bottom"
        },
        on: {
          "input": function input($event) {
            return _vm.$emit('input', false);
          },
          "beforeShow": _vm.$_onbeforeShow,
          "show": _vm.$_onShow,
          "hide": _vm.$_onHide,
          "maskClick": _vm.$_maskClick,
          "confirm": _vm.$_selectConfirm
        },
        model: {
          value: _vm.isPopupShow,
          callback: function callback($$v) {
            _vm.isPopupShow = $$v;
          },
          expression: "isPopupShow"
        }
      }, [_c('div', {
        staticClass: "nx-vmic-address-picker-content"
      }, [_vm.selectProvince || _vm.selectCity || _vm.selectDistrict ? _c('div', {
        staticClass: "city-select-tab"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.selectProvince,
          expression: "selectProvince"
        }],
        staticClass: "select-province",
        on: {
          "click": function click($event) {
            return _vm.selectTab(1);
          }
        }
      }, [_c('nx-transition', {
        attrs: {
          "name": "nx-tab-bar-ink-fixed"
        }
      }, [_vm.currentLevel == 1 ? _c('div', {
        staticClass: "active",
        style: _vm.styleObject
      }) : _vm._e()]), _vm._v("\n          " + _vm._s(_vm.selectProvince) + "\n        ")], 1), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.selectProvince && _vm.mode != 1,
          expression: "selectProvince && mode != 1"
        }],
        staticClass: "select-city",
        on: {
          "click": function click($event) {
            return _vm.selectTab(2);
          }
        }
      }, [_c('nx-transition', {
        attrs: {
          "name": "nx-tab-bar-ink-fixed"
        }
      }, [_vm.currentLevel == 2 ? _c('div', {
        staticClass: "active",
        style: _vm.styleObject
      }) : _vm._e()]), _vm._v("\n          " + _vm._s(_vm.selectCity || '请选择') + "\n        ")], 1), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.selectCity && _vm.mode == 3,
          expression: "selectCity && mode == 3"
        }],
        staticClass: "select-district",
        on: {
          "click": function click($event) {
            return _vm.selectTab(3);
          }
        }
      }, [_c('nx-transition', {
        attrs: {
          "name": "nx-tab-bar-ink-fixed"
        }
      }, [_vm.currentLevel == 3 ? _c('div', {
        staticClass: "active",
        style: _vm.styleObject
      }) : _vm._e()]), _vm._v("\n          " + _vm._s(_vm.selectDistrict || '请选择') + "\n        ")], 1)]) : _vm._e(), _c('div', {
        ref: "citylistDom",
        staticClass: "city-list"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.currentLevel == 1 && _vm.hotCity && _vm.hotCity.length > 0,
          expression: "currentLevel == 1 && hotCity && hotCity.length > 0"
        }],
        staticClass: "hot-city-list"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("热门城市")]), _c('div', {
        staticClass: "list"
      }, _vm._l(_vm.hotCity, function (item, index) {
        return _c('div', {
          key: index,
          staticClass: "hot-city-name",
          on: {
            "click": function click($event) {
              return _vm.selectAreaFromHotCity(item);
            }
          }
        }, [_c('span', [_vm._v(_vm._s(item))])]);
      }), 0)]), _vm._l(_vm.currentData, function (value, key) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.currentLevel <= _vm.mode,
            expression: "currentLevel <= mode"
          }],
          key: key,
          staticClass: "all-city-list"
        }, [_c('span', {
          staticClass: "letter-flag",
          attrs: {
            "id": 'letter-category-' + key
          }
        }, [_vm._v(_vm._s(key))]), _vm._l(value, function (item, index) {
          return _c('div', {
            key: index,
            staticClass: "city-name",
            class: _vm.currentName == item.name ? 'city-name-highlight' : '',
            style: _vm.currentName == item.name ? _vm.styleColorObject : '',
            attrs: {
              "name": item.name
            },
            on: {
              "click": function click($event) {
                return _vm.selectArea(item);
              }
            }
          }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]);
        })], 2);
      })], 2), _vm.showTouchBar ? _c('div', {
        ref: "letterTouchBarDom",
        staticClass: "letter-touch-bar",
        on: {
          "touchmove": _vm.touchLetterMove,
          "touchend": _vm.touchLetterEnd
        }
      }, _vm._l(_vm.currentData, function (value, key) {
        return _c('div', {
          key: key,
          staticClass: "letter",
          attrs: {
            "data-letter": key
          },
          on: {
            "click": function click($event) {
              return _vm.selectLetter(key, $event);
            }
          }
        }, [_vm._v("\n          " + _vm._s(key) + "\n        ")]);
      }), 0) : _vm._e(), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.key,
          expression: "key"
        }],
        staticClass: "letter-flag-highlight",
        style: _vm.styleObject
      }, [_vm._v(_vm._s(_vm.key))])])])], 1);
    },
    name: 'nx-vmic-address-picker',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _sheetsFixed.default.name, _sheetsFixed.default), (0, _defineProperty2.default)(_components, _transition.default.name, _transition.default), _components),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      addressData: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      hotCity: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      province: {
        type: String,
        default: ''
      },
      city: {
        type: String,
        default: ''
      },
      district: {
        type: String,
        default: ''
      },
      highlightColor: {
        type: String,
        default: '#579cf8'
      },
      componentHeight: {
        type: String,
        default: 'auto'
      },
      mode: {
        type: Number,
        default: 3
      },
      sheetsTitle: {
        type: String,
        default: '选择所在地区'
      },
      slideDownDisappear: {
        default: undefined
      },
      backClosePopup: {
        type: Boolean,
        default: false
      },
      backClosePopupCustomEvent: {
        type: String,
        default: 'popstate'
      },
      isWebviewFull: {
        type: Boolean,
        default: function _default() {
          if (_util.isCombineWallet && location.href && location.href.indexOf('sink=1') > -1) {
            return true;
          } else {
            return false;
          }
        }
      },
      showTouchBar: {
        type: Boolean,
        default: true
      }
    },
    data: function data() {
      return {
        isPopupShow: this.value,
        currentLevel: 1,
        selectProvince: '',
        selectCity: '',
        selectDistrict: '',
        currentData: '',
        styleObject: {
          backgroundColor: this.highlightColor
        },
        styleColorObject: {
          color: this.highlightColor
        },
        currentName: '',
        key: ''
      };
    },
    mixins: [_osProps.default],
    watch: {
      value: function value(val) {
        this.isPopupShow = val;
      }
    },
    computed: {},
    mounted: function mounted() {
      var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);

      if (isMobile) {
        document.body.appendChild(this.$el);
      } // var popupBoxDom = this.$el.getElementsByClassName('nx-popup-box')[0]
      // if (popupBoxDom) {
      //   popupBoxDom.style.height = this.componentHeight
      // }

    },
    beforeDestroy: function beforeDestroy() {
      var parentElement = this.$el.parentElement;

      if (parentElement && parentElement.contains(this.$el)) {
        parentElement.removeChild(this.$el);
      }
    },
    methods: {
      hidePopUp: function hidePopUp() {
        this.isPopupShow = false;
      },
      $_onbeforeShow: function $_onbeforeShow() {
        this.currentLevel = 1;
        this.currentName = '';
        this.currentData = this.addressData;
        this.selectProvince = this.province;
        this.selectCity = this.city;
        this.selectDistrict = this.district;

        if (this.selectDistrict) {
          this.selectTab(3);
        }

        if (this.selectCity && this.mode == 2) {
          this.selectTab(2);
        }

        if (this.mode == 1) {
          this.selectTab(1);
        }

        this.$emit('beforeShow');
      },
      $_onShow: function $_onShow() {
        this.$emit('show');
      },
      $_onHide: function $_onHide() {
        this.$emit('hide');
      },
      $_maskClick: function $_maskClick() {
        this.$emit('maskClick');
      },
      $_selectConfirm: function $_selectConfirm() {
        this.$emit('confirm', this.selectProvince, this.selectCity, this.selectDistrict);
      },
      selectTab: function selectTab(index) {
        var _this = this;

        this.currentLevel = index;

        if (index == 1) {
          this.currentData = this.addressData;
          this.currentName = this.selectProvince;
        }

        if (index == 2) {
          this.selectAreaFromTab2(this.selectProvince);
          this.currentName = this.selectCity;
        }

        if (index == 3) {
          this.selectAreaFromTab3(this.selectCity);
          this.currentName = this.selectDistrict;
        }

        this.$nextTick(function () {
          var activeDom = document.getElementsByName(_this.currentName)[0];

          if (activeDom) {
            activeDom.scrollIntoView();
          } else {
            _this.$refs.citylistDom.scrollTop = 0;
          }
        });
      },
      selectAreaFromTab2: function selectAreaFromTab2(item) {
        this.currentData = this.addressData;

        for (var key in this.currentData) {
          var first = this.currentData[key];

          for (var i = 0; i < first.length; i++) {
            if (item == first[i].name) {
              this.currentData = first[i].subAddress;
              return;
            } // var second = first[i].subAddress
            // for (var j in second) {
            //   for (var k = 0; k < second[j].length; k++) {
            //     if (item == second[j][k].name) {
            //       this.currentData = second
            //       return
            //     }
            //   }
            // }

          }
        }
      },
      selectAreaFromTab3: function selectAreaFromTab3(item) {
        this.currentData = this.addressData;

        for (var key in this.currentData) {
          var first = this.currentData[key];

          for (var i = 0; i < first.length; i++) {
            var second = first[i].subAddress;

            for (var j in second) {
              for (var k = 0; k < second[j].length; k++) {
                if (item == second[j][k].name) {
                  this.selectProvince = first[i].name;
                  this.selectCity = second[j][k].name;
                  this.currentName = this.selectCity;
                  this.currentData = second[j][k].subAddress;
                  this.currentLevel = 3;
                  return;
                }
              }
            }
          }
        }
      },
      selectAreaFromHotCity: function selectAreaFromHotCity(item) {
        for (var key in this.currentData) {
          var first = this.currentData[key];

          for (var i = 0; i < first.length; i++) {
            if (this.mode == 2) {
              if (item == first[i].name) {
                // 热门城市与一级城市名称相同表示是直辖市：北京市、上海市、天津市、重庆市
                this.selectProvince = first[i].name;
                this.selectCity = '';
                this.currentData = first[i].subAddress;
                this.currentLevel = 2;
                return;
              }
            }

            var second = first[i].subAddress;

            for (var j in second) {
              for (var k = 0; k < second[j].length; k++) {
                if (item == second[j][k].name) {
                  this.selectProvince = first[i].name;
                  this.selectCity = second[j][k].name;
                  this.currentName = this.selectCity;
                  this.currentData = second[j][k].subAddress;
                  this.selectDistrict = '';
                  this.currentLevel = 3;

                  if (this.mode == 2) {
                    this.$_selectConfirm();
                    this.hidePopUp();
                  }

                  return;
                }
              }
            }
          }
        }
      },
      selectArea: function selectArea(item) {
        if (this.currentLevel == 1) {
          this.selectProvince = item.name;

          if (this.mode == 1) {
            this.$_selectConfirm();
            this.hidePopUp();
            return;
          }

          this.currentData = item.subAddress;
          this.selectCity = '';
          this.selectDistrict = '';

          for (var key in this.currentData) {
            for (var i = 0; i < this.currentData[key].length; i++) {
              if (this.selectProvince == this.currentData[key][i].name) {
                this.currentLevel++;
                this.selectArea(this.currentData[key][i]);
                return;
              }
            }
          }
        }

        if (this.currentLevel == 2) {
          this.currentData = item.subAddress;
          this.selectCity = item.name;
          this.selectDistrict = '';

          if (this.mode == 2) {
            this.$_selectConfirm();
            this.hidePopUp();
          }
        }

        if (this.currentLevel == 3) {
          this.selectDistrict = item.name;
          this.$_selectConfirm();
          this.hidePopUp();
        }

        this.currentName = item.name;

        if (this.currentLevel < 3) {
          this.currentLevel++;
        }

        this.$refs.citylistDom.scrollTop = 0;
      },
      selectLetter: function selectLetter(key, event) {
        var _this2 = this;

        this.key = key;
        var a = document.getElementById('letter-category-' + key);
        a && a.scrollIntoView();
        this.removeLetterActiveClass();
        event.target.classList.add('active');
        setTimeout(function () {
          _this2.key = '';

          _this2.removeLetterActiveClass();
        }, 2000);
      },
      touchLetterMove: function touchLetterMove(e) {
        e.preventDefault(); // 阻止滚动事件的发生

        var x = e.targetTouches[0].clientX,
            y = e.targetTouches[0].clientY,
            touchdom = document.elementFromPoint(x, y),
            key = touchdom && touchdom.getAttribute('data-letter');
        this.removeLetterActiveClass();
        touchdom.classList.add('active');

        if (key) {
          this.key = key;
          var a = document.getElementById('letter-category-' + key);
          a && a.scrollIntoView();
        }
      },
      touchLetterEnd: function touchLetterEnd() {
        var _this3 = this;

        setTimeout(function () {
          _this3.key = '';

          _this3.removeLetterActiveClass();
        }, 2000);
      },
      removeLetterActiveClass: function removeLetterActiveClass() {
        var letterDom = this.$refs.letterTouchBarDom.children;
        var doms = Array.from(letterDom);

        if (doms && doms.length > 0) {
          doms.forEach(function (element) {
            element.classList.remove('active');
          });
        }
      }
    }
  };
  _exports.default = _default2;
});